import { render } from "./Yandex.svg?vue&type=template&id=1e8d4ebd"
const script = {}
script.render = render

export default script